/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingrefresh1Inputs */

const en_crosspostingrefresh1 = /** @type {(inputs: Crosspostingrefresh1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh`)
};

const de_crosspostingrefresh1 = /** @type {(inputs: Crosspostingrefresh1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisieren`)
};

/**
* | output |
* | --- |
* | "Refresh" |
*
* @param {Crosspostingrefresh1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingrefresh1 = /** @type {((inputs?: Crosspostingrefresh1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingrefresh1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingrefresh1(inputs)
	return de_crosspostingrefresh1(inputs)
});
export { crosspostingrefresh1 as "crosspostingRefresh" }